export default function ipoDisclaimer($) {
	const COOKIE_NAME = 'ipo_disclaimer_accepted';
	const roots = $('[data-module="ipoDisclaimer"]');
	if (!roots.length) return;

	function setCookie(name, value, days = 1) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${value}; expires=${expires}; path=/`;
	}

	roots.each(function () {
		const $root = $(this);
		const redirect = $root.data('redirect') || '/';

		const $form = $root.find('[data-disclaimer-form]');
		if (!$form.length) return;

		const allowed = $form
			.find('input[name="allowed_list[]"]')
			.map(function () {
				return $(this).val();
			})
			.get();
		const $views = $root.find('[data-view]');
		const show = (name) => {
			$views.each(function () {
				const $v = $(this);
				$v.toggleClass('hidden', $v.data('view') !== name);
			});
		};

		const $selects = $form.find('select');
		const $startBtn = $form.find('[data-accept-btn]');

		function validate() {
			let ok = true;
			$selects.each(function () {
				if (!$(this).val()) ok = false;
			});
			$startBtn.prop('disabled', !ok);
		}
		$selects.on('change', validate);

		$form.on('submit', function (e) {
			e.preventDefault();
			if ($startBtn.prop('disabled')) return;
			const c1 = $selects.eq(0).val();
			const c2 = $selects.eq(1).val();
			const ok = allowed.includes(c1) && allowed.includes(c2);
			show(ok ? 'step-2' : 'denied');
		});

		$root.find('[data-go-back]').on('click', () => show('step-1'));
		$root.find('[data-next-step]').on('click', () => show('step-3'));

		$root.find('[data-final-confirm]').on('click', () => {
			setCookie(COOKIE_NAME, 'allowed', 30);
			window.location.href = redirect;
		});

		$form.find('[data-decline-btn]').on('click', function (e) {
			if (history.length > 1) {
				e.preventDefault();
				history.back();
			}
		});
	});
}
